'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["availabilityStatus", "requiredServices", "actionContext", "className"];
import FintechOutageBannerTitle from './FintechOutageBannerTitle';
import ActionContextPropType from '../propTypes/ActionContextPropType';
import { ACTION_CONTEXTS } from '../constants/actionContexts.constants';
import { THIRD_PARTY_SERVICES } from '../constants/thirdPartyServices.constants';
import FintechOutageBannerMessage from './FintechOutageBannerMessage';
import AvailabilityStatusPropType from '../propTypes/AvailabilityStatusPropType';
import ThirdyPartyServicesPropType from '../propTypes/ThirdyPartyServicesPropType';
import PropTypes from 'prop-types';
import { FireAlarm } from 'foundations-components/transitional/components/FireAlarm';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const FintechOutageBanner = _ref => {
  let {
      availabilityStatus,
      requiredServices = [THIRD_PARTY_SERVICES.ZUORA],
      actionContext = ACTION_CONTEXTS.ANY,
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (requiredServices.indexOf(THIRD_PARTY_SERVICES.ZUORA) > -1) {
    const zuoraStatus = availabilityStatus.zuora;
    const isZuoraDown = (zuoraStatus || {}).isDown;
    if (isZuoraDown) {
      return /*#__PURE__*/_jsx(FireAlarm, Object.assign({
        closeable: false,
        type: "warning",
        titleText: /*#__PURE__*/_jsx(FintechOutageBannerTitle, {
          actionContext: actionContext,
          serviceAvailabilityStatus: zuoraStatus
        }),
        marginBlockEnd: className === 'm-bottom-4' ? '400' : '0'
      }, rest, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: /*#__PURE__*/_jsx(FintechOutageBannerMessage, {
            serviceAvailabilityStatus: zuoraStatus
          })
        })
      }));
    }
  }
  return null;
};
FintechOutageBanner.propTypes = {
  availabilityStatus: AvailabilityStatusPropType.isRequired,
  requiredServices: ThirdyPartyServicesPropType,
  actionContext: ActionContextPropType,
  className: PropTypes.string
};
export default FintechOutageBanner;